<template>
  <div class="pms-finder-home">
    <div v-if="loading">
      <!-- <header class="section section--sm hero gradient is-reversed nav-space" style="min-height: 422px;">
        <div class="container container-2">
          <div class="grid grid--center-y">
              <div class="grid-item is-sm-12 is-md-12 is-10 text-white text-left">
                <h1>{{ $t('hero.heading') }}</h1>
                <p class="pb-0">{{ $t('hero.subHeading') }}</p>
                <p>{{ $t('hero.subHeadingInfo') }}</p>
              </div>
            </div>
        </div>
      </header> -->
      <div class="space-lg-top space-bottom text-center">
        <img style="max-width:64px;" src="//resources.siteminder.com/services/pms-finder/static/loading.gif" alt="">
      </div>
    </div>
    <list v-else :partnerData="partners" :serviceType="this.defaultServiceType" />
  </div>
</template>

<script>
/* eslint-disable */
// @ is an alias to /src
import axios from 'axios'
import { isEmpty } from 'lodash';
import { sortBy, slice, orderBy } from 'lodash'
import List from '@/components/List.vue'
import { getCode } from 'country-list';

export default {
  name: 'home',
  props: ["defaultServiceType"],
  components: {
    List
  }, 
  data () {
    return {
      loading: true,
      partners: null,
    }
  },

  methods: {

    async fetchPartnerData () {
      try {
        const { data } = await axios.get(
          'https://integrations-api.siteminder.com/public/partners/all?lang=en'
        )

        const records = Array.isArray(data.data) ? data.data : []

        this.partners = records
          .filter(partner => this.isConsultant(partner))
          .map(partner => this.formatPartner(partner))
      } catch (error) {
        console.error('Unable to fetch consultant data', error)
        this.partners = []
      } finally {
        this.loading = false
      }
    },

    isConsultant (partner) {
      if (!Array.isArray(partner.categories)) {
        return false
      }

      const consultantCategories = [
        'software_selection_advisory',
        'digital_marketing_website_development',
        'hotel_consulting_service',
        'revenue_management_strategy',
        'software_implementation'
      ]

      return partner.categories.some(category =>
        consultantCategories.includes(category)
      )
    },

    getFeatures (partner) {
      const categoryMap = {
        software_selection_advisory: 'software',
        revenue_management_strategy: 'revenue',
        digital_marketing_website_development: 'marketing',
        hotel_consulting_service: 'consulting',
        software_implementation: 'implementation'
      }

      if (!Array.isArray(partner.categories)) {
        return []
      }

      return partner.categories
        .map(category => categoryMap[category])
        .filter(Boolean)
    },

    getSalesEmail (partner) {
      if (!Array.isArray(partner.contacts)) {
        return ''
      }

      const leads = partner.contacts.filter(
        contact => Number(contact.is_lead) === 1
      )

      // Prefer the primary contact among the leads.
      const primaryLead = leads.find(
        contact => Number(contact.is_primary) === 1
      )

      if (primaryLead) {
        return primaryLead.email || ''
      }

      if (leads.length) {
        return leads[0].email || ''
      }

      const primary = partner.contacts.find(
        contact => Number(contact.is_primary) === 1
      )

      if (primary) {
        return primary.email || ''
      }

      return partner.contacts.length
        ? partner.contacts[0].email || ''
        : ''
    },

    getCountryCodes (partner) {
      if (!Array.isArray(partner.regions)) {
        return []
      }

      const countries = []

      partner.regions.forEach(region => {
        if (!Array.isArray(region.countries)) {
          return
        }

        region.countries.forEach(country => {
          const code = getCode(country)

          if (code && !countries.includes(code)) {
            countries.push(code)
          }
        })
      })

      return countries
    },

    getCities (partner) {
      if (!Array.isArray(partner.regions)) {
        return ''
      }

      const cities = []

      partner.regions.forEach(region => {
        if (!Array.isArray(region.cities)) {
          return
        }

        region.cities.forEach(city => {
          const value = String(city || '').trim()

          if (value && !cities.includes(value)) {
            cities.push(value)
          }
        })
      })

      return cities.join(', ')
    },

    getBadge (partner) {
      if (!Array.isArray(partner.badges) || !partner.badges.length) {
        return ''
      }

      return partner.badges[0].badge_type || ''
    },

    formatPartner (partner) {
      return {
        name: partner.name,
        logo: partner.logo_url,

        salesEmail: this.getSalesEmail(partner),

        enDesc: partner.description || '',
        fr: partner.description_fr || '',
        es: partner.description_es || '',
        it: partner.description_it || '',
        de: partner.description_de || '',
        pt: partner.description_pt || '',

        features: this.getFeatures(partner),
        countries: this.getCountryCodes(partner),

        city: this.getCities(partner),
        priority: -1,
        badge: this.getBadge(partner),
        property: '',

        href: partner.partner_page_url || partner.website_url || ''
      }
    },

    setLanguage () {
      const loadedLang = document.querySelector('html').getAttribute('lang')

      if (loadedLang) {
        this.$i18n.locale = loadedLang
      }
    }
  },

  mounted () {
    this.setLanguage()
    this.fetchPartnerData()
  }
}
</script>

<style lang="scss" scoped>
  .loading--overlay {
    min-height: 100vh;
    padding-top: 20vh;
    width: 100%;
    z-index: 99999;
  }
</style>
